import React, { useEffect, useState } from 'react'
import { NuDate, NuInput, NuTextArea } from '../../../../Components/Utils/Input';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import { Modal, notification } from 'antd';
import axiosInstance from '../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import { useParams } from 'react-router-dom';
import * as yup from 'yup';
import Attachement, { videotype } from '../../../../Components/Utils/CustomAttrachmentupload';
import { useToast } from '../../../../Components/Others/ToastServices';
import CloseIcon from '../../../../Components/Icons/Close';
import Doc from '../../../../Components/Icons/Doc';
import Xls from '../../../../Components/Icons/Xls';
import Txt from '../../../../Components/Icons/Txt';
import Pdf from '../../../../Components/Icons/Pdf';
import Video from '../../../../Components/Icons/Video';
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "PDF",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];

const EditEmailSent =  ({EditNew,open, getData=()=>{}, onCancel, data,firstProject,id }) => {
  
  const {officeId} = useParams();
  const [api, contextHolder] = notification.useNotification();
  const [createNew, setCreateNew] = useState({
      date:"",to:"",cc:"",subject:""
  });
  useEffect(() => {
    data&&setCreateNew({
      date:data.date,
      to:data.to,
      cc:data.cc,
      subject:data.subject
    })
  },[data])
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema:yup.object({
      // name:yup.string().required("Name is Requried")
  }),
    onSubmit: (value,{resetForm}) => {
      // const withBranchId = {
      //   ...value,
      //   branch: officeId
      // }
      axiosInstance.put(`/Equipments/${data?.id}`, value)
      .then((res) => {
          console.log("res",res.data.status);
          if (res.data.status) {
            api.success({
              message: `Equipments Update successfully`,
              description: res?.data?.msg || "Added In The Equipments",
              placement: "bottomRight",
            });
            getData(id);
            resetForm();
            onCancel();
          } else {
            api.error({
              message: `Equipments Upadate failed`,
              description: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          
          api.error({
            message: `failed`,
            description: err?.data?.msg || "Sever error (or) Network error",
            placement: "bottomRight",
          });
        });
    },
  });

  const dummycc = [
    { value: 1, label: "bob.builder@example.com" },
    { value: 2, label: "samuel.lang@example.com" },
    { value: 3, label: "jeff.bezos@example.com" },
    { value: 4, label: "john.doe@example.com" },
    { value: 5, label: "jane.smith@example.com" },

  ];

  const [selectedFile, setSelectedFile] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileExtention, setFileExtention] = useState("");
  const toast = useToast();
  const [image, setImage] = useState([]);
  const [fileRemoveList, setFileRemoveList] = useState([]);

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];
    files.map((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size to big`,
          description: `${item.name} is Removed and not Uploaded`,
          // placement: "bottomRight",
        });
      }
    });
    let tempArr = [];
    setSelectedFile(fileArr);
    files.map((item) => {
      if (item.size < maxFileSize) {
        let fileName = item?.name;
        console.log("fname", fileName);
        let fileExtention = fileName.split(".").reverse()[0];
        if (filetype?.includes(fileExtention)) {
          tempArr.push(fileName);
        } else {
          let x = URL.createObjectURL(item);
          tempArr.push(x);
        }
      }
    });
    console.log(tempArr, "temp");
    setImage(tempArr);
  }

  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      console.log(data.attachments, "ghjkllgd");
      setFilePathList(data?.attachments);

      setRemoveFilePathList(data?.attachments);
    }
  }, [data]);

  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList.file !== item);
    let removeFile = filePathList.find((itemList) => itemList.file === item);
    console.log("llll", filterList);
    setFileRemoveList([...fileRemoveList, removeFile.file]);
    setFilePathList(filterList);
  }

  function handleImageClick(img) {
    let Ext = img?.file_name.split(".").reverse()[0];
    setSelectedImage(img);
    setFileExtention(Ext);
    setIsModalOpen(true);
  }

  return (
    <>
    {contextHolder}
    <Modal
      open={open}
      title={data ? "Edit Email" : "Create Email"}
      width={"50%"}
      className="my-modal"
      centered
      onCancel={onCancel}
      footer={[]}
    >
    <form onSubmit={formik.handleSubmit} >
     <div className=" w-full flex flex-wrap">
   
     <NuDate
                         label="Date"
                         placeholder="Date"
                         formik={formik}
                         name="date"
                        
                         width="w-full "
                       />
             <NuInput
              label="To"
              placeholder="to"
              formik={formik}
              name="to"
              width="w-full"
              new_width="w-full"

            />
                        <DropDownAddMetaData
                          label="cc"
                          placeholder="Choose"
                          // Options={cc}
                          Options={dummycc}

                          formik={formik}
                          name="cc"
                          width="w-full "
                          // getFunc={refbrand}
                          displayProperty={"cc"}
                          propertyName={"cc_Email"}
                          FixPosition={false}
                          PortalTarget={false}
                           />
             <NuTextArea
              label="Subject"
              placeholder="Subject"
              formik={formik}
              name="subject"
              width="w-full"
              new_width="w-full"

            />
             <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Attachement :
                </p>
              </div>
              <div className="md:flex justify-between mt-5 px-3 w-full">
                <div className="w-full flex gap-2 items-center flex-wrap">
                  {data?.attachments &&
                    filePathList?.map((imgs, idx) => {
                      console.log("img", imgs);
                      let Ext = imgs?.file_name.split(".").reverse()[0];
                      return (
                        <div
                          className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                          key={idx}
                          style={{
                            border: "1px solid gray",
                            borderColor:
                              "rgb(148 163 184 / var(--tw-bg-opacity))",
                          }}
                        >
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                            onClick={() => UpdateAttachmentList(imgs?.file)}
                          >
                            <CloseIcon color="white" height="8" width="8" />
                          </div>
                          <div
                            className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                            onClick={() => handleImageClick(imgs)}
                          >
                            <div className=" w-8 h-8">
                              {videotype.includes(Ext) ? <Video /> : null}

                              {Ext === ("docx" || "doc" || "txt") ? (
                                <Doc />
                              ) : Ext === ("xlsx" || "xls") ? (
                                <Xls />
                              ) : Ext === "txt" ? (
                                <Txt />
                              ) : Ext === "pdf" ? (
                                <Pdf />
                              ) : Ext === "PDF" ? (
                                <Pdf />
                              ) : Ext === "pptx" ? (
                                <>No file</>
                              ) : (
                                <img src={imgs?.file} alt="#" width="120%" />
                              )}
                            </div>
                            <p className=" w-[50px] text-[11px] truncate">
                              {imgs?.file_name}
                            </p>
                          </div>
                        </div>
                      );
                    })}

                  <Attachement
                    handleChange={handleImageChange}
                    preview={image || ""}
                    width="w-full md:w-1/2"
                    label="Attach"
                    multiple={true}
                  />
                </div>
              </div>
              <div className="flex w-full justify-end gap-4 mt-4">
                <button
                type="button"
                className="w-20 bg-gray-400 py-2 rounded-lg cursor-pointer text-sm outline-none border-none hover:bg-gray-500 text-white"
                onClick={onCancel}
              >
                Close
              </button>
     <button
                type="submit"
                className="w-20 bg-blue-600 py-2 rounded-lg cursor-pointer text-sm outline-none border-none hover:bg-blue-700 text-white"

              >
                Submit
              </button>
                <button
                type="submit"
                className="w-20 border border-blue-600 bg-blue-400 py-2 rounded-lg text-white cursor-pointer text-sm outline-none hover:bg-blue-700"
                >
                Send
              </button>
  
             
            </div>
          </div>
     
    </form>
    </Modal>
    </>
  );
};




export default EditEmailSent